import React from "react";
import { Button } from "@design-system/Button/Button";
import { Menu } from "@design-system/Menu/Menu.lib";
import { AttachIcon, CheckIcon, PlusIcon } from "@icons";

interface ComposerInsertMenuProps {
    disabled?: boolean;
    onAttachFile: () => void;
    onToggleChecklist: () => void;
    onToggleBulletList: () => void;
    onToggleNumberedList: () => void;
}

const BulletListIcon = () => (
    <svg viewBox="0 0 14 14" aria-hidden="true">
        <circle cx="2.5" cy="3" r="1.1" fill="currentColor" />
        <rect
            x="5.5"
            y="2.2"
            width="7"
            height="1.6"
            rx="0.4"
            fill="currentColor"
        />
        <circle cx="2.5" cy="7" r="1.1" fill="currentColor" />
        <rect
            x="5.5"
            y="6.2"
            width="7"
            height="1.6"
            rx="0.4"
            fill="currentColor"
        />
        <circle cx="2.5" cy="11" r="1.1" fill="currentColor" />
        <rect
            x="5.5"
            y="10.2"
            width="7"
            height="1.6"
            rx="0.4"
            fill="currentColor"
        />
    </svg>
);

const NumberedListIcon = () => (
    <svg viewBox="0 0 14 14" aria-hidden="true">
        <text x="0" y="4.5" fontSize="5" fontWeight="700" fill="currentColor">
            1
        </text>
        <rect
            x="5.5"
            y="2.2"
            width="7"
            height="1.6"
            rx="0.4"
            fill="currentColor"
        />
        <text x="0" y="8.5" fontSize="5" fontWeight="700" fill="currentColor">
            2
        </text>
        <rect
            x="5.5"
            y="6.2"
            width="7"
            height="1.6"
            rx="0.4"
            fill="currentColor"
        />
        <text x="0" y="12.5" fontSize="5" fontWeight="700" fill="currentColor">
            3
        </text>
        <rect
            x="5.5"
            y="10.2"
            width="7"
            height="1.6"
            rx="0.4"
            fill="currentColor"
        />
    </svg>
);

export const ComposerInsertMenu: React.FC<ComposerInsertMenuProps> = ({
    disabled,
    onAttachFile,
    onToggleChecklist,
    onToggleBulletList,
    onToggleNumberedList,
}) => (
    <Menu.Root
        disabled={disabled}
        side="top"
        trigger={
            <Button variant="secondary" size="md" iconOnly aria-label="Insert">
                <PlusIcon />
            </Button>
        }
    >
        <Menu.Item leading={<AttachIcon aria-hidden />} onClick={onAttachFile}>
            Attach file
        </Menu.Item>
        <Menu.Item
            leading={<CheckIcon aria-hidden />}
            onClick={onToggleChecklist}
        >
            Checklist
        </Menu.Item>
        <Menu.Item leading={<BulletListIcon />} onClick={onToggleBulletList}>
            Bullet list
        </Menu.Item>
        <Menu.Item
            leading={<NumberedListIcon />}
            onClick={onToggleNumberedList}
        >
            Numbered list
        </Menu.Item>
    </Menu.Root>
);
